<template>
  <div class="dropdown-menu">
    <span class="dropdown-menu__title" v-if="title" v-html="title"></span>
    <div class="dropdown-menu__dropdown" @click="active = !active">
      <button class="dropdown-menu__selected">
        <span v-html="currentPage.title"></span>
        <img src="static/svg/dropdown.svg">
      </button>
      <transition name="fade" mode="out-in" appear>
        <ul class="dropdown-menu__list" v-if="active">
          <li class="dropdown-menu__item" v-for="link in array" :key="array.index">
            <a href="#" class="dropdown-menu__link" :class="{'dropdown-menu__link--active': (currentIndex == link.index)}"  v-on:click.prevent="updateIndex(link.index)" v-html="link.title"></a>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
    };
  },
  props: ['array', 'currentIndex', 'title'],
  computed: {
    currentPage() {
      return this.array[this.currentIndex];
    },
  },
  methods: {
    updateIndex(index) {
      this.$emit('updateIndex', index);
    },
  },
};
</script>

<style lang="scss">
  @import '../scss/helpers.scss';

  .dropdown-menu {
    display: flex;
    align-items: center;
    flex-grow: 1;

    &__dropdown {
      position: relative;
      text-align: center;
    }

    &__title {
      display: none;

      @include not-mobile {
        font-size: 12px;
        font-weight: 300;
        line-height: 20px;
        margin-right: 15px;
        display: block;
      }

      @include landscape {
        display: none;
      }
    }

    &__selected {
      background: #E6EBEF;
      border-radius: 20px;
      border: 0;
      font-size: 12px;
      font-weight: 300;
      padding: 12px 20px;
      position: relative;
      text-align: left;
      width: 154px;
      outline: none;
      font-family: 'Univers', Helvetica, Arial, sans-serif;

      img {
        position: absolute;
        right: 20px;
        top: 16px;
      }
    }

    &__list {
      background: #fff;
      top: 12px;
      box-shadow: 0px 6px 8px rgba(0,0,0,0.16);
      border-radius: 4px;
      left: 50%;
      list-style: none;
      margin: 0;
      position: absolute;
      text-align: center;
      transform: translateX(-50%);
      width: 180px;
      padding: 13px 0;
      transition: all .5s cubic-bezier(0.19, 1, 0.22, 1);
    }

    &__link {
      display: block;
      text-decoration: none;
      padding: 13px 0;
      color: #000;
      font-size: 12px;
      font-weight: 300;

      &--active {
        font-weight: bold;
        opacity: .5;
        pointer-events: none;
      }
    }
  }
  
  .fade-enter, .fade-leave-to {
    bottom: -200px;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/DropdownMenu.vue